import React from 'react';
import LegalLayout, { L } from './LegalLayout';
import { OPERATOR } from '../../legal/operator';

export default function CookiePolicyPage() {
  return (
    <LegalLayout title="Cookies & local storage">
      <L.P>
        {OPERATOR.productName} keeps its footprint small. We do <strong>not</strong> use advertising
        or third-party analytics cookies. The Service only stores a few items in your browser’s
        local storage to keep you signed in and remember your UI preferences.
      </L.P>

      <L.H2>What we store</L.H2>
      <L.UL>
        <L.LI><strong>Authentication tokens</strong> — strictly necessary to keep you signed in. Cleared on sign-out or account deletion.</L.LI>
        <L.LI><strong>Theme preference</strong> — your chosen light or dark appearance.</L.LI>
        <L.LI><strong>UI preferences</strong> — small per-portfolio settings such as the default chart range, the last-used chart tab, your color choices and which columns you want to see in tables.</L.LI>
        <L.LI><strong>Cookie consent flag</strong> — your acknowledgement that you have read this notice, so we don’t prompt you on every page load.</L.LI>
      </L.UL>

      <L.H2>What we do not use</L.H2>
      <L.UL>
        <L.LI>No third-party advertising cookies.</L.LI>
        <L.LI>No marketing or social-media trackers.</L.LI>
        <L.LI>No cross-site tracking pixels.</L.LI>
      </L.UL>

      <L.P>
        If we ever add product analytics, you will be asked to opt in before any tracking starts,
        and this page will be updated accordingly.
      </L.P>

      <L.H2>Clearing local storage</L.H2>
      <L.P>
        You can clear all of the items above at any time from your browser’s privacy settings. Note
        that doing so will sign you out and reset your UI preferences.
      </L.P>

      <L.H2>Contact</L.H2>
      <L.P>Questions? Write to <L.Mail to={OPERATOR.supportEmail} />.</L.P>
    </LegalLayout>
  );
}
